const candidateSearchActions = {
  FETCH_CANDIDATE_SEARCH_ROLE_START: 'FETCH_CANDIDATE_SEARCH_ROLE_START',
  FETCH_CANDIDATE_SEARCH_ROLE_DONE: 'FETCH_CANDIDATE_SEARCH_ROLE_DONE',
  FETCH_CANDIDATE_SEARCH_ROLE_ERROR: 'FETCH_CANDIDATE_SEARCH_ROLE_ERROR',
  FETCH_CANDIDATE_SEARCH_ROLE_CANCELLED: 'FETCH_CANDIDATE_SEARCH_ROLE_CANCELLED',

  fetchCandidateSearchRole: () => ({
    type: candidateSearchActions.FETCH_CANDIDATE_SEARCH_ROLE_START,
  }),
};

export default candidateSearchActions;
